import { EditableTitle, type EditableTitleProps } from "@coval/ui"

type ResourceBreadcrumbTitleProps = Pick<
  EditableTitleProps,
  | "value"
  | "onSave"
  | "label"
  | "placeholder"
  | "maxLength"
  | "validate"
  | "disabled"
  | "saving"
> & {
  "data-testid"?: string
}

/** The open resource's name as the last breadcrumb, renamed in place. It stands in for `BreadcrumbPage`, so it is the page's `h1` and carries the current-page marker; the rename control stays inside the heading. */
export function ResourceBreadcrumbTitle({
  "data-testid": testId,
  ...titleProps
}: ResourceBreadcrumbTitleProps) {
  return (
    // Named for the resource itself: read from its content, the heading would
    // take the rename button's "Edit …" label.
    <h1
      className="min-w-0"
      aria-current="page"
      aria-label={titleProps.value || titleProps.placeholder}
      data-testid={testId}
    >
      <EditableTitle size="sm" {...titleProps} />
    </h1>
  )
}
